var React = require('react');

function Flood (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 18.75a5.647 5.647 0 0 1-5.647-5.647C.353 9.338 6 2.985 6 2.985s5.647 6.353 5.647 10.118A5.647 5.647 0 0 1 6 18.75z","fill":"currentColor"}));
}

Flood.defaultProps = {"width":"12","height":"21","viewBox":"0 0 12 21"};

module.exports = Flood;

Flood.default = Flood;
